import { useEffect } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { PanelDefaultRoute, SuperAdminDefaultRoute, getRoutes } from "./routes";
import usePanelAbility from "@src/utility/hooks/use-panel-ability";
import BlankLayout from "@layouts/types/blank-layout";
import Error from "@src/views/pages/misc/error";
import GoogleAuth from "../views/panel/auth/login/google-auth";
import NotAuthorized from "@src/views/pages/misc/not-authorized";
import SubmitSurvey from "@panel/surveys/submit";
import { getItemFromStore, isSuperAdminUrl } from "../utility/helpers/utils";

const Router = () => {
    const allRoutes = getRoutes();
    const getHomeRoute = () => {
        const adminToken = getItemFromStore("token");
        const superadminToken = getItemFromStore("token-superadmin");

        if (!adminToken && !superadminToken) return "/login";

        const hasBoth = adminToken && superadminToken;
        const isSuperAdmin = isSuperAdminUrl();

        if ((adminToken && !superadminToken) || (hasBoth && !isSuperAdmin)) {
            return PanelDefaultRoute;
        }
        if ((superadminToken && !adminToken) || (hasBoth && isSuperAdmin)) {
            return SuperAdminDefaultRoute;
        }
    };

    const { handlePanelAbility } = usePanelAbility();

    useEffect(() => {
        const storedUserInfo = getItemFromStore("userInfo");
        if (storedUserInfo?.user) {
            handlePanelAbility({ userInfo: storedUserInfo });
        }
    }, []);

    // Use the getHomeRoute() function to get the destination route
    const destinationRoute = getHomeRoute();
    const routes = useRoutes([
        {
            path   : "/",
            index  : true,
            element: <Navigate replace to={destinationRoute} />
        },
        {
            path   : "/auth/verify/google",
            element: <GoogleAuth />
        },
        {
            path    : "/misc/not-authorized",
            element : <BlankLayout />,
            children: [
                {
                    path   : "/misc/not-authorized",
                    element: <NotAuthorized />,
                    meta   : {
                        publicRoute: true,
                        layout     : "blank"
                    }
                }
            ]
        },
        {
            path   : "/survey/response",
            element: <SubmitSurvey />
        },
        {
            path    : "*",
            element : <BlankLayout />,
            children: [{ path: "*", element: <Error /> }]
        },

        ...allRoutes
    ]);

    return routes;
};

export default Router;
